import { BodyPix, load, toMask } from "@tensorflow-models/body-pix";

export async function loadBodyPix() {
    return load({
        architecture: "MobileNetV1",
        outputStride: 16,
        multiplier: 0.75,
        quantBytes: 4,
    });
}

export interface BodySegementationFrameOptions {
    drawPoses?: boolean;
    flipHorizontal?: boolean;
}

/**
 * Feeds an image to BodyPix to estimate segmentation for a single frame
 */
export async function getBodySegmentationMaskForCurrentFrame(net: BodyPix, video: HTMLVideoElement) {
    const segmentation = await net.segmentPerson(video, {
        internalResolution: "high",
        segmentationThreshold: 0.59,
        maxDetections: 1,
        scoreThreshold: 0.2,
        nmsRadius: 20,
    });
    const foregroundColor = { r: 255, g: 255, b: 255, a: 255 };
    const backgroundColor = { r: 0, g: 0, b: 0, a: 0 };
    return toMask(segmentation, foregroundColor, backgroundColor, true);
}
